<template>
	<TheHeader></TheHeader>
	
	<div class="container-fluid">
		<div class="container">
			<form name="form">
				<div class="contain row">
					<TheSidebar></TheSidebar>
					
					<div class="page-container card col-md-8">
						<ThePageHeader @import-event="importFile" @export-event="exportFile" importTooltip="CSV upload of sheet list" exportTooltip="Export sheet list to CSV" :renderImport="!isLoading" :renderExport="!isLoading" :isImporting="isImporting" :isExporting="isExporting"></ThePageHeader>
						
						<div class="row" v-if="pageError == ''">
							
							<div class="row p-3 align-items-center">
								<div class="col-md-4">
									<Button class="p-button-sm" @click="add" label="Create New Sheet"/>
								</div>

								<div class="col-md-8" v-if="!isLoading">
									<div class="d-flex justify-content-end align-items-center">
										<TheLoading v-if="isImporting || isExporting"></TheLoading>

										<SplitButton class="p-button-sm" icon="pi pi-download" label="Import Templates" :model="importTemplatesItems" id="splitButton-importTemplates" @click="openSplitButtonMenu('splitButton-importTemplates')" :disabled="isImporting || isExporting"></SplitButton>
										<span class="p-1"></span>

										<SplitButton class="p-button-sm" icon="pi pi-file-export" label="Export Templates" :model="exportTemplatesItems" id="splitButton-exportTemplates" @click="openSplitButtonMenu('splitButton-exportTemplates')" :disabled="isImporting || isExporting"></SplitButton>
										<span class="p-1"></span>

										<FileUpload class="p-button-sm" uploadIcon="pi pi-download" mode="basic" chooseLabel="Bulk Import" v-tooltip.top="'Bulk Import - CSV upload that does the same thing as the plain Import button, plus one extra step: it closes any sheet not present in the file'" :customUpload="true" :auto="true" :disabled="isImporting || isExporting" @uploader="(event: any) => bulkImportFile(event.files)" />
									</div>
								</div>
							</div>

							<FileUpload ref="importTemplatesZip" class="d-none" mode="basic" :customUpload="true" :auto="true" @uploader="(event: any) => importAllTemplates(event.files, 'zip')" :accept="'zip,application/zip,application/x-zip,application/x-zip-compressed'" />
							<FileUpload ref="importTemplatesExcel" class="d-none" mode="basic" :customUpload="true" :auto="true" @uploader="(event: any) => importAllTemplates(event.files, 'excel')" :accept="'.xls,.xlsx,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'" />
							
							<div class="row p-3 pb-0">
								<label><b>Search existing Sheet by:</b></label>
							</div>
							
							<div class="row p-3">
								<div class="col-md-4">
									<InputText class="p-inputtext" type="text" maxlength="10" placeholder="Code" v-model="filterCodeModel.value" />
								</div>
								
								<div class="col-md-4">
									<InputText class="p-inputtext" type="text" maxlength="50" placeholder="Title" v-model="filterNameModel.value" />
								</div>
								
								<div class="col-md-4">
									<Dropdown :options="getActiveStatuses(statuses)" optionLabel="name" optionValue="value" placeholder="Status" v-model="filterStatusModel.value" />
								</div>
							</div>
							
							<div class="row p-3">
								<div class="col-md-5 d-flex align-items-center">
									<Button class="p-button-sm" @click="find(1)" label="Search"/>
									<span class="p-1"></span>
									<Button class="p-button-sm p-button-secondary" @click="reset" label="Reset"/>
								</div>
									
								<div class="col-md-7">
									<Paginator :first="paginator" :pageLinkSize="3" :rows="pagination.itemsPerPage" :totalRecords="pagination.totalItems" @page="find($event.page + 1)" v-if="pagination.currentPage != 0" />
								</div>
							</div>
							
							<div class="row">
								<div class="col-md-12 p-4">
									<table class="p-datatable p-component p-datatable-hoverable-rows align-middle mb-0 w-12">
										<thead class="p-datatable-thead">
											<tr>
												<th style="width: 8%;">#</th>
												<th style="width: 15%; cursor: pointer;" @click="sort('x.code')">Code <span class="pi" :class="[sortingModel.columnName == 'x.code' ? (sortingModel.isAscending ? 'pi-sort-amount-up-alt' : 'pi-sort-amount-down') : 'pi-fw pi-sort-alt']"></span></th>
												<th style="width: 35%; cursor: pointer;" @click="sort('x.name')">Title <span class="pi" :class="[sortingModel.columnName == 'x.name' ? (sortingModel.isAscending ? 'pi-sort-amount-up-alt' : 'pi-sort-amount-down') : 'pi-fw pi-sort-alt']"></span></th>
												<th style="width: 15%; cursor: pointer;" @click="sort('x.sequence')">Sequence <span class="pi" :class="[sortingModel.columnName == 'x.sequence' ? (sortingModel.isAscending ? 'pi-sort-amount-up-alt' : 'pi-sort-amount-down') : 'pi-fw pi-sort-alt']"></span></th>
												<th style="width: 15%;" class="text-center">Status</th>
											</tr>
										</thead>
										<tbody class="p-datatable-tbody" v-if="!isLoading">
											<tr v-for="(sheet, index) in pagination.sheets" :key="index" v-on:click="view(sheet)">
												<td>{{((pagination.currentPage - 1) * pagination.itemsPerPage) + index + 1}}</td>
												<td>{{sheet.code}}</td>
												<td>{{sheet.name}}</td>
												<td>{{sheet.sequence}}</td>
												<td class="text-center">
													<Badge class="mr-2" :class="[sheet.status == 'Active' ? 'p-badge-success' : 'p-badge-danger']" :value="sheet.status"></Badge>
												</td>
											</tr>
										</tbody>
									</table>
								</div>
								
								<div class="error-no-record" v-if="!isLoading && pagination.sheets.length == 0">
									<FontAwesomeIcon :icon="['fas', 'image']" size="2x" />
									<h6><span>No Record Found</span></h6>
								</div>
								
								<TheTableLoading v-if="isLoading"></TheTableLoading>
							</div>
						</div>
						
						<TheInvalidImportDialog title="Sheet" :visible="isDialogVisible" :data="invalidData" @close-dialog-event="closeDialog" @proceed-import-event="proceedImport"></TheInvalidImportDialog>

						<ThePageError @back-event="cancel" :pageError="pageError" v-if="pageError != ''"></ThePageError>
					</div>
					
					<TheFooter></TheFooter>
				</div>
			</form>
		</div>
	</div>
</template>

<script lang="ts">
	import { defineComponent } from "vue";
	import { useRoute } from "vue-router";
	import store from "@/store";
	import sheetApi from "@/api/sheet-api";
	import statusMixin from "@/mixin/status";
	import sheetTypeMixin from "@/mixin/sheet-type";
	import roleMixin from "@/mixin/role";
	
	import TheHeader from "@/components/TheHeader.vue";
	import TheFooter from "@/components/TheFooter.vue";
	import TheSidebar from "@/components/TheSidebar.vue";
	import ThePageHeader from "@/components/ThePageHeader.vue";
	import TheTableLoading from "@/components/TheTableLoading.vue";
	import ThePageError from "@/components/ThePageError.vue";
	import TheLoading from "@/components/TheLoading.vue";
	import templateApi from "@/api/template-api";
	import TheInvalidImportDialog from "@/components/TheInvalidImportDialog.vue"
	
	export default defineComponent({
		mixins: [statusMixin, sheetTypeMixin, roleMixin],
		components: {
			TheHeader,
			TheFooter,
			TheSidebar,
			ThePageHeader,
			TheTableLoading,
			ThePageError,
			TheLoading,
			TheInvalidImportDialog
		},
		data() {
			return {
				pageError: (store.getters.error == undefined ? '' : store.getters.error),
				pagination: (store.getters.getCached.page == null ? {currentPage: 1, itemsPerPage: 10, sheets: [], totalItems: 0} : store.getters.getCached.page.pagination),
				sortingModel: (store.getters.getCached.page == null ? {columnName: "x.sequence", isAscending: true} : store.getters.getCached.page.sortingModel),
				filterCodeModel: (store.getters.getCached.page == null ? {value: ""} : store.getters.getCached.page.filterCodeModel),
				filterNameModel: (store.getters.getCached.page == null ? {value: ""} : store.getters.getCached.page.filterNameModel),
				filterTypeModel: (store.getters.getCached.page == null ? {value: ""} : store.getters.getCached.page.filterTypeModel),
				filterStatusModel: (store.getters.getCached.page == null ? {value: null} : store.getters.getCached.page.filterStatusModel),
				sheetType: (useRoute().meta.sheetType == null ? "" : useRoute().meta.sheetType + ""),
				isLoading: false,
				isBulkImporting: false,
				isBulkImportProcess: false,
				isImporting: false,
				isExporting: false,
				isDialogVisible: false,
				invalidData: {} as any
			}
		},
		mounted: function() {
			if (this.pageError == '') {
				this.find(this.pagination.currentPage);
			}
		},
		computed: {
			paginator() {
				return ((this.pagination.currentPage - 1) * this.pagination.itemsPerPage);
			},
			// Declared as computed rather than data so `this` resolves to the fully typed component
			// instance - inside data() the methods are not yet known to TypeScript.
			importTemplatesItems() {
				return [
					{
						label: 'Zip (txt)',
						icon: 'pi pi-folder',
						command: () => {
							this.openFileUpload('importTemplatesZip');
						}
					},
					{
						label: 'Excel',
						icon: 'pi pi-file-excel',
						command: () => {
							this.openFileUpload('importTemplatesExcel');
						}
					}
				];
			},
			exportTemplatesItems() {
				return [
					{
						label: 'Zip (txt)',
						icon: 'pi pi-folder',
						command: () => {
							this.exportAllTemplates('zip');
						}
					},
					{
						label: 'Excel',
						icon: 'pi pi-file-excel',
						command: () => {
							this.exportAllTemplates('excel');
						}
					}
				];
			}
		},
		methods: {
			sort(columnName: string) {
				if (this.sortingModel.columnName == columnName) {
					this.sortingModel.isAscending = !this.sortingModel.isAscending;
				}
				
				else {
					this.sortingModel.columnName = columnName;
					this.sortingModel.isAscending = true;
				}
				this.find(1);
			},
			find(page: number) {
				this.isLoading = true;
				
				store.getters.getCached.page = {
					pagination: JSON.parse(JSON.stringify(this.pagination)),
					sortingModel: JSON.parse(JSON.stringify(this.sortingModel)),
					filterCodeModel: JSON.parse(JSON.stringify(this.filterCodeModel)),
					filterNameModel: JSON.parse(JSON.stringify(this.filterNameModel)),
					filterTypeModel: JSON.parse(JSON.stringify(this.filterTypeModel.value = this.sheetType)),
					filterStatusModel: JSON.parse(JSON.stringify(this.filterStatusModel)),
				};
				
				sheetApi.sheetFind({
						paginationModel: {currentPage: page},
						sortingModel: this.sortingModel,
						filterCodeModel: this.filterCodeModel,
						filterNameModel: this.filterNameModel,
						filterTypeModel: this.filterTypeModel,
						filterStatusModel: this.filterStatusModel
					})
					.then(response => {
						this.pagination = {currentPage: response.data.currentPage, itemsPerPage: response.data.itemsPerPage, sheets: response.data.rowSet, totalItems: response.data.totalItems}
						if (store.getters.getCached.page == null) {
							store.getters.getCached.page = {};
						}
						store.getters.getCached.page.pagination = this.pagination;
						this.isLoading = false;
					})
					.catch(error => {
						this.isLoading = false;
						this.$toast.add({severity: "error", summary: "Error", detail: error, life: 6000});
					})
			},
			reset() {
				this.pagination = {currentPage: 1, itemsPerPage: 10, sheets: [], totalItems: 0};
				this.sortingModel = {columnName: "x.sequence", isAscending: true};
				this.filterCodeModel = {value: ""};
				this.filterNameModel = {value: ""};
				this.filterStatusModel = {value: null};
				this.find(1);
			},
			add() {
				this.$router.push("/admin/sheet/add/" + this.sheetType.toLowerCase());
			},
			view(sheet: any) {
				this.$router.push("/admin/sheet/view/" + this.sheetType.toLowerCase() + "/" + sheet.identifier);
			},
			openSplitButtonMenu(buttonId: string) {
				var splitButton = document.getElementById(buttonId)?.getElementsByClassName('p-splitbutton-menubutton')[0] as HTMLElement;
				splitButton.click();
			},
			openFileUpload(refName: string) {
				var uploader = this.$refs[refName] as any;
				uploader?.$el?.querySelector('input[type="file"]')?.click();
			},
			importAllTemplates(files: any, fileType: string) {
				this.isImporting = true;
				var formData = new FormData();
				formData.append('file', files[0]);
				formData.append('filterTypeModel', JSON.stringify(this.filterTypeModel));
				formData.append('fileType', fileType);
				templateApi.templateImportAll(
						formData
					)
					.then((response: any) => {
						this.isImporting = false;
						this.$toast.add({severity: "success", summary: "Success", detail: response.message, life: 6000});
					})
					.catch(error => {
						this.isImporting = false;
						this.$toast.add({severity: "error", summary: "Error", detail: error, life: 6000});
					})
			},
			bulkImportFile(file: any) {
				this.isBulkImporting = true;
				this.isBulkImportProcess = true;
				var formData = new FormData();
				formData.append('file', file[0]);
				
				sheetApi.sheetImport(formData)
					.then((response: any) => {
						this.isBulkImporting = false;
						this.invalidData = response.data;
						this.isDialogVisible = true;
					})
					.catch(error => {
						this.isBulkImporting = false;
						this.$toast.add({severity: "error", summary: "Error", detail: error, life: 6000});
					})
			},
			importFile(file: any) {
				this.isImporting = true;

				var formData = new FormData();
				formData.append('file', file[0]);
				
				sheetApi.sheetImport(formData)
					.then((response: any) => {
						this.isImporting = false;
						this.invalidData = response.data;
						this.isDialogVisible = true;
					})
					.catch(error => {
						this.isImporting = false;
						this.$toast.add({severity: "error", summary: "Error", detail: error, life: 6000});
					})
			},
			proceedImport(isOverride: boolean) {
				this.isImporting = true;

				let tempInvalidData = JSON.parse(JSON.stringify(this.invalidData));
				
				if (isOverride == false && tempInvalidData.warningCount > 0) {
					tempInvalidData.invalidRows.forEach((invalidRow: any, index: any) => {
						if (invalidRow.type == "Warning") {
							invalidRow.type = "Error";
							return invalidRow;
						}
					});
				}

				sheetApi.sheetImportProceed({'invalidData': tempInvalidData, 'isBulkImportProcess': this.isBulkImportProcess})
					.then((response: any) => {
						this.isImporting = false;
						this.$toast.add({severity: "success", summary: "Success", detail: response.message, life: 6000});
						this.isDialogVisible = false;
						this.isBulkImportProcess = false;
						this.find(1);
					})
					.catch(error => {
						this.isImporting = false;
						this.isDialogVisible = false;
						this.isBulkImportProcess = false;
						this.$toast.add({severity: "error", summary: "Error", detail: error, life: 6000});
					})
			},
			exportAllTemplates(fileType: string) {
				this.isExporting = true;
				
				templateApi.templateExportAll({
						filterCodeModel: this.filterCodeModel,
						filterNameModel: this.filterNameModel,
						filterTypeModel: this.filterTypeModel,
						filterStatusModel: this.filterStatusModel,
						fileType: fileType
					})
					.then(response => {
						this.isExporting = false;
					})
					.catch(error => {
						this.isExporting = false;
						this.$toast.add({severity: "error", summary: "Error", detail: error, life: 6000});
					})
			},
			exportFile() {
				this.isExporting = true;
				
				sheetApi.sheetExport({
						filterCodeModel: this.filterCodeModel,
						filterNameModel: this.filterNameModel,
						filterTypeModel: this.filterTypeModel,
						filterStatusModel: this.filterStatusModel
					})
					.then(response => {
						this.isExporting = false;
					})
					.catch(error => {
						this.isExporting = false;
						this.$toast.add({severity: "error", summary: "Error", detail: error, life: 6000});
					})
			},
			closeDialog() {
				this.isDialogVisible = false;
			}
		}
	});
</script>
